<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.txt_title }} </p-header>
  <div class="dialog__body__trade-cancel-confirm">
    <p>{{ data.txt_message }}</p>
    <p *ngIf="!data.showIds">{{ data.txt_sub_message }}</p>
    <p *ngIf="data.showIds">{{ data.txt_sub_message }}</p>
    <p *ngIf="data.showIds" class="overflow-ellipsis" [title]="data.txt_sub_ids">
      {{ data.txt_sub_ids }}
    </p>
  </div>
  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionCancelTrade_no()"
      label="No"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionCancelTrade_yes()"
      label="Yes"
    ></button>
  </p-footer>
</p-dialog>
